﻿import buttonLoader from '../../utilities/buttonLoader.js';

var mypageReceipt = {};

mypageReceipt = {

  init: function () {
    //var me = this;

    //var buttons = document.getElementsByClassName('receipt__submitReceipt');

    //if (buttons) {

    //  Array.prototype.forEach.call(buttons, (button) => {

    //    button.addEventListener('click', function (e) {

    //      e.preventDefault();

    //      //me.submit(button);

    //    });

    //  });
    //}

  },

  submit: function (button) {
    var me = this;

    var xhr = new XMLHttpRequest();
    xhr.open('POST', button.getAttribute('href'));

    button.disabled = true;

    xhr.onload = function () {

      var resp = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {

        if (resp.success) {

          alert(resp.message);

        } else {

          alert(resp.message);
          
        }

      } else {

        alert(resp.message);

      }

      button.disabled = false;

    };

    xhr.send();
    
  }

};

mypageReceipt.initialize = function () {
  mypageReceipt.init();
};

module.exports = mypageReceipt;
